module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "partial-footer"
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-51c74520!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/partials/PartialFooter.vue
// module id = 998
// module chunks = 34